<template>
  <SListItem
    :id="`user-card-${user.id}`"
    :class="{ 'with-icon-text': !!iconText }"
    :title="user.meta.displayname"
    :description="child ? user.school.name : $t('settings.index.card.title')"
    :icon-color="userOptions.color"
    :icon="child ? userOptions.icon : ''"
    :icon-text="iconText"
    :badges="[{ text: badgeDescription, color: 'secondary' }]"
    right-action-icon="icon-chevron-right"
    icon-size="lg"
    data-cy="user-profile"
    :data-title="user.meta.displayname"
    :disabled="disabled"
    @click="$emit('select-user', user)"
  >
    <template #icon-additional-bottom v-if="user.meta.is_paused && !child">
      <img src="/img/miscellaneous/ui/mute-status.svg"
           alt=""
           class="user-muted-status"
           loading="lazy"
      />
      <span class="sr-only">{{ $t('global.user_status.muted.title') }}</span>
    </template>
  </SListItem>
</template>

<script>
import EntityMixin from 'src/mixins/miscellaneous/entityMixin.js'
export default {
  name: 'UserCard',
  mixins: [EntityMixin],
  props: {
    user: {
      type: Object,
      default: () => ({}),
    },

    child: {
      type: Boolean,
      default: false,
    },

    disabled: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    userShort() {
      // TODO Extend API endpoint to read this value from user.meta
      return this.user ? this.user.firstname.charAt(0) + this.user.lastname.charAt(0) : ''
    },

    userOptions() {
      return this.getEntityData(this.user)
    },

    badgeDescription() {
      return this.user?.primary_role.translated_description
    },

    iconText() {
      return this.child ? '' : this.userShort
    },
  },

  emits: ['select-user'],
}
</script>

<style scoped lang="scss">
.with-icon-text {
  :deep(.type-teacher-light-bg) {
    background-color: $color-blue-dark !important;
  }

  :deep(.type-student-light-bg) {
    background-color: $color-green-dark !important;
  }

  :deep(.type-parent-light-bg) {
    background-color: $color-orange-dark !important;
  }

  :deep(.type-teacher),
  :deep(.type-student),
  :deep(.type-parent) {
    color: $color-white !important;
  }
}
</style>
